import React, { useEffect, useState } from 'react';
// import Orders from './order-list/Orders';
import CustomerList from './customers/Customers';
import {
  deleteCustomer,
  getCustomerTableList,
  updateDetails
} from 'nursd-dashboard/api/customerTable';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import { toast } from 'react-toastify';
import Update_Customer from './update_customer';
import { Card, Col, Row } from 'react-bootstrap';
import IconButton from 'components/common/IconButton';
import { Link } from 'react-router-dom';
import paths from 'routes/paths';

const Customer = () => {
  const [customers, setCustomers] = useState([]);
  const [downloadData, setDownloadData] = useState([]);
  const [loadingScreen, setLoadingScreen] = useState(true);
  const [show, setShow] = useState(false);
  const [data, setData] = useState(undefined);

  const { authToken, location, organization } = useAuth();

  const getCustomer = async () => {
    setLoadingScreen(true);
    try {
      const cusList = await getCustomerTableList(
        authToken,
        location,
        organization
      );

      const list = cusList.sort((a, b) =>
        a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase())
      );
      let array = [];
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        let obj = {
          id: item.id,
          name: item.firstName + ' ' + item.lastName,
          avatar: {
            name: item.firstName + ' ' + item.lastName
          },
          email: item.email,
          password: item.password,
          address: item.fullAddress,
          phone: item.phoneOne,
          status: item?.active,
          joined: item.createdAt,
          mrn: item?.additionalFields[0]?.mrnNumber,
          original: item
        };
        array.push(obj);
      }

      console.log(array);

      let arrayDownload = [];
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        let obj = {
          firstName: item.firstName,
          lastName: item.lastName,
          fullAddress: item.fullAddress,
          city: item.city,
          state: item.state,
          zipCode: item.zipCode,
          gender: item.gender,
          phoneOne: item.phoneOne,
          phoneTwo: item.phoneTwo,
          email: item.email,
          password: item.password
        };
        arrayDownload.push(obj);
      }

      if (
        list.length === array.length &&
        list.length === arrayDownload.length
      ) {
        setCustomers(array);
        setDownloadData(arrayDownload);
        setLoadingScreen(false);
      }
    } catch (error) {
      setCustomers([]);
      setDownloadData([]);
      setLoadingScreen(false);
    }
  };

  const updateCustomer = async (id, value) => {
    try {
      const res = await updateDetails(authToken, id, {
        active: value
      });

      if (!value) {
        toast.error(
          `${
            res?.firstName + ' ' + res?.lastName
          } has been Un-Activated successfully.`,
          {
            theme: 'colored'
          }
        );
      } else {
        toast.success(
          `${
            res?.firstName + ' ' + res?.lastName
          } has been Activated successfully.`,
          {
            theme: 'colored'
          }
        );
      }
      getCustomer();
    } catch (error) {
      console.log('data save error:', error);
    }
  };

  const deleteRecord = async item => {
    // console.log("Delete", item);
    await deleteCustomer(authToken, item?.id)
      .then(() => {
        getCustomer();
        toast.success(
          `${item?.firstName + ' ' + item?.lastName} deleted successfully.`,
          {
            theme: 'colored'
          }
        );
      })
      .catch(e => console.log(e));
  };

  useEffect(() => {
    if (location !== '') {
      getCustomer();
    }
  }, [authToken, location]);

  return (
    <>
      {!show ? (
        <Card>
          {customers?.length === 0 && (
            <>
              <Card.Header className="bg-body-tertiary">
                <Row className="align-items-center">
                  <Row className="g-2">
                    <Col>
                      <h5 className="mb-0 text-secondary">
                        Patient Records ({customers?.length})
                      </h5>
                    </Col>
                  </Row>
                  <Row className="g-2">
                    <Col xs="auto" className="d-flex order-md-0">
                      <Link to={paths.nursd_customer_upload}>
                        <IconButton
                          variant="success"
                          iconClassName="me-2"
                          icon="plus"
                          size="sm"
                        >
                          <span className="text-light ms-1">Upload CSV</span>
                        </IconButton>
                      </Link>
                      <IconButton
                        variant="falcon-default"
                        size="sm"
                        icon="plus"
                        transform="shrink-3"
                        className="mx-2"
                      >
                        <Link to={paths.nursd_customer_form}>
                          <span className="d-none text-dark d-sm-inline-block ms-1">
                            New
                          </span>
                        </Link>
                      </IconButton>
                    </Col>
                  </Row>
                </Row>
              </Card.Header>
            </>
          )}
          {location === '' ? (
            <div className="m-3">
              <p>Select Location Id</p>
            </div>
          ) : loadingScreen ? (
            <div className="m-3">
              <p>Loading...</p>
            </div>
          ) : customers?.length === 0 ? (
            <div className="m-3">
              <Row>
                <Col>
                  <p>{location} - No Data Available</p>
                </Col>
                <Col>
                  <IconButton
                    variant="success"
                    iconClassName="me-2"
                    icon="plus"
                    size="sm"
                  >
                    <Link to={paths.nursd_customer_upload}>
                      <span className="text-light ms-1">Upload CSV</span>
                    </Link>
                  </IconButton>
                  <IconButton
                    variant="falcon-default"
                    size="sm"
                    icon="plus"
                    transform="shrink-3"
                    className="mx-2"
                  >
                    <Link to={paths.nursd_customer_form}>
                      <span className="d-none text-dark d-sm-inline-block ms-1">
                        New
                      </span>
                    </Link>
                  </IconButton>
                </Col>
              </Row>
            </div>
          ) : (
            <Card.Body className="bg-body-tertiary px-1 pb-1 pt-0 fs-10">
              <CustomerList
                updateCustomer={updateCustomer}
                deleteRecord={deleteRecord}
                customers={customers}
                downloadData={downloadData}
                // setCustomers={setCustomers}
                getCustomer={getCustomer}
                setShow={setShow}
                setData={setData}
              />
            </Card.Body>
          )}
        </Card>
      ) : (
        <Card>
          <Card.Header className="bg-body-tertiary">
            <h5>Update Patient</h5>
          </Card.Header>
          <Card.Body className="bg-body-tertiary p-3">
            <Update_Customer
              data={data}
              authToken={authToken}
              setShow={setShow}
              getCustomer={getCustomer}
            />
          </Card.Body>
        </Card>
      )}
    </>
  );
};

Customer.propTypes = {};

export default Customer;
